__turbopack_context__.v({
  "img": "ServiceItem-module-scss-module__3kyggW__img",
  "item": "ServiceItem-module-scss-module__3kyggW__item",
  "link": "ServiceItem-module-scss-module__3kyggW__link",
  "section": "ServiceItem-module-scss-module__3kyggW__section",
  "textWrapper": "ServiceItem-module-scss-module__3kyggW__textWrapper",
  "title": "ServiceItem-module-scss-module__3kyggW__title",
});
